// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wrap[data-v-395c307a]{left:0;position:fixed;width:100%;z-index:98}.btn[data-v-395c307a],.wrap[data-v-395c307a]{bottom:.88rem;display:flex;justify-content:center}.btn[data-v-395c307a]{align-items:center;background:linear-gradient(45deg,#4effd9,#e0ff2e);border-radius:.42rem;box-shadow:0 .16rem .32rem 0 rgba(0,0,0,.5);color:#070b17;font-size:.32rem;font-weight:500;height:.84rem;padding:0 .68rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
